import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getTrackingEstimatedTimeOfDeliveryTitleStyles, getTrackingEstimatedTimeOfDeliveryDateErrorStyles } from './TrackingEstimatedTimeOfDeliveryStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

function TrackingEstimatedTimeOfDelivery(_ref) {
  let {
    estimatedTimeOfDelivery,
    hasIncident,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs("div", {
    ...otherProps,
    children: [jsx(Typography, {
      css: getTrackingEstimatedTimeOfDeliveryTitleStyles,
      variant: "body2",
      bold: true,
      component: "div",
      children: t('tracking-details.titles.estimated-time-of-delivery')
    }), jsx(Typography, {
      css: hasIncident && getTrackingEstimatedTimeOfDeliveryDateErrorStyles,
      variant: "body2",
      bold: true,
      component: "div",
      children: estimatedTimeOfDelivery.format('DD MMMM, YYYY')
    })]
  });
}

export { TrackingEstimatedTimeOfDelivery };
//# sourceMappingURL=TrackingEstimatedTimeOfDelivery.js.map
